import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  IconButton,
} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import CriSection from "../../components/CriSection";
import NaturalAreasList from "../../constants/natural_area_essays";
import { useState } from "react";
import PdfDialog from "../../components/PdfDialog";

const NaturalAreas = () => {
  const [showPdfDialog, setShowPdfDialog] = useState(false);
  const [pdfUrl, setPdfUrl] = useState("");
  const [pdfTitle, setPdfTitle] = useState("");

  const onShowPDF = ({ title, pdf }: { title: string; pdf: string }) => {
    setShowPdfDialog(true);
    setPdfTitle(title);
    setPdfUrl(pdf);
  };

  return (
    <CriSection alternate={true}>
      <Typography
        sx={{
          fontSize: "36px",
          fontWeight: 300,
          lineHeight: 1,
          width: "100%",
          textAlign: "center",
        }}
      >
        Natural Areas
      </Typography>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={{
          marginTop: "24px",
        }}
      >
        <Table>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#E0E0E0",
              }}
            >
              <TableCell
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                }}
              >
                Description
              </TableCell>
              <TableCell
                align="right"
                sx={{
                  fontWeight: 600,
                  fontSize: "18px",
                }}
              >
                File
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {NaturalAreasList.map((row, index) => (
              <TableRow
                key={index}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell component="th" scope="row">
                  {row.name}
                </TableCell>
                <TableCell align="right">
                  <IconButton
                    color="primary"
                    onClick={() =>
                      onShowPDF({ title: row.name, pdf: row.file })
                    }
                  >
                    <ArticleIcon />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <PdfDialog
        open={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
        title={pdfTitle}
        pdfUrl={pdfUrl}
      />
    </CriSection>
  );
};

export default NaturalAreas;
